// Moving here from Quiz due to circular dependency
export enum ContainerFrequencyOptions {
  All = 2,
  Some = 1,
  None = 0,
}
